import client from './client';

export const campaignApi = {
  list: (params?: { page?: number; limit?: number }) => client.get('/campaigns', { params }),
  get: (id: string, params?: { wa_account_id?: string }) => client.get(`/campaigns/${id}`, { params }),
  listSendBatches: (id: string, params?: { wa_account_id?: string; limit?: number }) =>
    client.get(`/campaigns/${id}/send-batches`, { params }),
  createSendBatch: (id: string, payload: { content: string; media_url?: string; wa_account_id?: string }) =>
    client.post(`/campaigns/${id}/send-batches`, payload),
  cancelSendBatch: (campaignId: string, batchId: string) =>
    client.post(`/campaigns/${campaignId}/send-batches/${batchId}/cancel`),
};
